// extracted by mini-css-extract-plugin
export default {"title":"styles_title__PeDNS","line":"styles_line__nGYGE","body":"styles_body__mDlOo","buttons":"styles_buttons__qG6dO"};